var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_12943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2968 1.55972C14.2152 1.25825 14.0561 0.983414 13.8353 0.762571C13.6144 0.541729 13.3396 0.38259 13.0381 0.301C11.9345 0 7.49257 0 7.49257 0C7.49257 0 3.05046 0.00911109 1.94679 0.310111C1.64532 0.391706 1.37048 0.550853 1.14965 0.771706C0.928818 0.992559 0.769695 1.26741 0.688127 1.56889C0.354294 3.52989 0.224794 6.518 0.697294 8.40056C0.77887 8.70203 0.937997 8.97687 1.15883 9.19771C1.37966 9.41855 1.6545 9.57769 1.95596 9.65928C3.05963 9.96028 7.50163 9.96028 7.50163 9.96028C7.50163 9.96028 11.9436 9.96028 13.0472 9.65928C13.3487 9.5777 13.6235 9.41856 13.8443 9.19772C14.0652 8.97688 14.2243 8.70203 14.3059 8.40056C14.658 6.43678 14.7665 3.4505 14.2968 1.55972Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07874 7.11437L9.76362 4.98004L6.07874 2.8457V7.11437Z",
    fill: "#D70365"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_12943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 10,
    fill: "white",
    transform: "translate(0.388672)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d748dbc7ef3448f3ea60f54b61df0bfd.svg";
export { ForwardRef as ReactComponent };